/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_QtyInputs */

const en_roster_qty = /** @type {(inputs: Roster_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qty`)
};

const es_roster_qty = /** @type {(inputs: Roster_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cant`)
};

const fr_roster_qty = /** @type {(inputs: Roster_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qté`)
};

const de_roster_qty = /** @type {(inputs: Roster_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge`)
};

const id_roster_qty = /** @type {(inputs: Roster_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jml`)
};

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const ja_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const zh_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const ar_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const it_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const ru_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const pt_roster_qty = en_roster_qty;

/** @type {(inputs: Roster_QtyInputs) => LocalizedString} */
const ko_roster_qty = en_roster_qty;

/**
* | output |
* | --- |
* | "Qty" |
*
* @param {Roster_QtyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_qty = /** @type {((inputs?: Roster_QtyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_QtyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_qty(inputs)
	if (locale === "es") return es_roster_qty(inputs)
	if (locale === "fr") return fr_roster_qty(inputs)
	if (locale === "de") return de_roster_qty(inputs)
	if (locale === "ja") return ja_roster_qty(inputs)
	if (locale === "zh") return zh_roster_qty(inputs)
	if (locale === "ar") return ar_roster_qty(inputs)
	if (locale === "id") return id_roster_qty(inputs)
	if (locale === "it") return it_roster_qty(inputs)
	if (locale === "ru") return ru_roster_qty(inputs)
	if (locale === "pt") return pt_roster_qty(inputs)
	return ko_roster_qty(inputs)
});